:host {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: calc(100% * var(--grid-column-width, calc(1 / 12)) * 0.6);
  row-gap: calc(var(--grid-row-gap, 60) * 1px);
  margin-bottom: calc(var(--grid-row-gap, 60) * 1px);
  margin-left: 15px;
  margin-right: 15px;
  max-width: 1200px;
  position: relative;

  @include breakpoint($medium) {
    margin-left: 30px;
    margin-right: 30px;
  }

  @include breakpoint($desktop) {
    margin-left: 35px;
    margin-right: 35px;
  }

  @include breakpoint($xlarge) {
    margin-left: auto;
    margin-right: auto;
  }

  hr {
    grid-column: span 12;
    border: 0;
    border-bottom: 1px solid $ui-grey;
    margin: 0;
  }

  ::slotted(div) {
    grid-column: span 12;
  }
}
